// @flow

import React, { type Node } from 'react';
import { Separator } from './separator';
import { Message } from './message';
import { CardInfo } from './card-info';
import { ChooseAnotherMethodMessage } from './choose-another-method-message';

export function Retry(): Node {
  return (
    <div data-test-id="retry-message">
      <Message />
      <Separator />
      <CardInfo />
      <Separator line />
      <ChooseAnotherMethodMessage />
    </div>
  );
}
